import { combineReducers } from 'redux';
import { tasksReducer } from './tasks';
import { materialReducer } from './materials';
import { labourReducer } from './labours';
import { defectReducer } from './defects';
import { taskHistoryReducer } from './taskHistory';
import { productHistoryReducer } from './productHistory';
import { warehouseProductReducer } from './warehouseProduct';
import { alertReducer } from './alert';
import { externalSystemReducer } from './externalSystem';
import { tasksNewReducer } from './tasksNew';
import surveyReducer from '../slices/surveySlice'
import workOrderCargoReducer from '../slices/workOrderCargoSlice'
import consentReducer from '../slices/consentSlice'
import generalReducer from '../slices/generalSlice'
import paymentReducer from '../slices/paymentSlice'
import cuteStarReducer from '../slices/cuteStarSlice'
import communicationReducer from '../slices/communicationSlice'

const rootReducer = combineReducers({
  tasks1: tasksReducer,
  materialReducer,
  labourReducer,
  defectReducer,
  taskHistoryReducer,
  productHistoryReducer,
  warehouseProductReducer,
  alertReducer,
  externalSystemReducer,
  tasksNewReducer,
  survey: surveyReducer,
  workOrderCargo: workOrderCargoReducer,
  consent: consentReducer,
  general: generalReducer,
  payment: paymentReducer,
  cuteStar: cuteStarReducer,
  communication: communicationReducer
});

export default rootReducer;
